module.exports = __webpack_public_path__ + "img/lora_nogps.244e2156.svg";